import cx from 'classnames';
import React from 'react';

import styles from './index.module.scss';

/* eslint-disable react/prop-types */
export default ({ onClose, isClosed, _id, content }) => (
  <div className={cx(styles.root, isClosed && styles.hidden)}>
    <p>{content}</p>
    <button className={styles.close} onClick={() => onClose(_id)} />
  </div>
);
